import { useAppConfig } from '@plato/app-core/hooks/use-app-config';
import { keepPreviousData } from '@tanstack/react-query';
import { isEmpty } from 'lodash-es';
import { resolveActiveMetric } from '../../../server/utils/explorer-utils.ts';
import { api } from '../../../utils/api.ts';
import { useCustomerListFilters } from './use-customer-list-filters.tsx';

export function useCustomerListSummary() {
    const { appliedFilters } = useCustomerListFilters();
    const { billingStatus } = resolveActiveMetric(useAppConfig());

    // Check if user has applied any filters (non-empty arrays)
    const hasFilters = Object.keys(appliedFilters).some((key) => {
        const filterKey = key as keyof typeof appliedFilters;
        // Skip sortingFilter and searchString as they're not real filters
        if (filterKey === 'sortingFilter' || filterKey === 'searchString') {
            return false;
        }

        return !isEmpty(appliedFilters[filterKey]);
    });

    const { data, isLoading } = api.platoUser.getManyCustomers.getAggregatesWithPreferredMetric.useQuery(
        { ...appliedFilters, billingStatus },
        {
            enabled: hasFilters,
            placeholderData: hasFilters ? keepPreviousData : undefined,
        },
    );

    if (isLoading || !data || !hasFilters) {
        return {};
    }

    return { summary: data };
}
